import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {permissions} from '../../../permissions';
import {Subscription} from 'rxjs/Subscription';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTabGroup} from '@angular/material';
import {UserStatusService} from '../user-status/user-status.service';
import {UserService} from '../../../services/user.service';
import {ToastrService} from 'ngx-toastr';
import {roles} from '../../../roles';

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss'],
    providers: [
        UserStatusService,
        UserService
    ],
    preserveWhitespaces: true
})
export class UserFormComponent implements OnInit, OnDestroy {

    public action: String = '';

    public loading: boolean;
    public record: any;
    public errors: { [key: string]: any; };
    private filters: { [key: string]: any; };
    public allowPasswordUpdate: boolean;

    public permissions = permissions;
    private roles = roles;
    private subscription: Subscription;

    @ViewChild('tabGroup') tabGroup: MatTabGroup;

    constructor(
        private route: ActivatedRoute,
        private title: Title,
        private router: Router,
        private userService: UserService,
        private toast: ToastrService
    ) {
        this.title.setTitle('Admin - User Creation');
    }

    ngOnInit() {
        this.action = this.route.snapshot.url[1].toString();
        this.loading = false;
        this.allowPasswordUpdate = false;
        this.record = {
            id: null,
            name: '',
            username: '',
            email: '',
            status: UserStatusService.STATUS_ACTIVE,
            password: '',
            repeatPassword: '',
            role: '',
            companies: [],
            masterCustomers: []
        };
        this.filters = {};
        this.errors = {};

        if (this.action === 'create') {
            this.record.role = null;
        } else {
            this.loading = true;
            this.record.role = null;
            this.userService.viewSubordinate( this.route.snapshot.params.id ).subscribe(result => {
                if (result.success) {
                    if (
                        result.data.role.toString() === this.roles.oesCompanyAdmin
                    ) {
                        this.filters['parentView'] = 'company';
                        this.filters['childView'] = 'none';
                    } else if (
                        result.data.role.toString() === this.roles.oesCompanyUser
                    ) {
                        this.filters['parentView'] = 'company';
                        this.filters['childView'] = 'customer';
                    } else if (result.data.role.toString() === this.roles.oesMasterCustomerUser) {
                        this.filters['parentView'] = 'master-customer';
                        this.filters['childView'] = 'plant';
                    } else {
                        this.filters['parentView'] = 'none';
                        this.filters['childView'] = 'none';
                    }
                    this.preloadData( result.data );
                } else {
                    this.toast.error('Failed to load user data.', 'Error');
                    this.clickCancel();
                }
            }, () => {
                this.toast.error('User data fetch request timed out.', 'Service Error');
                this.clickCancel();
            });
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    preloadData( modelData = null ) {
        this.userService.getSubordinatePreload(this.filters).subscribe(result => {
            if (this.filters['parentView'] === 'company') {
                this.record.masterCustomers = [];
                this.record.companies = result.data.map(company => {
                    company['label'] = company.CO1_NAME;
                    company['selected'] = (Number(company.selected) === 1);
                    company['children'] = company.children.map(customer => {
                        customer['label'] = customer.CU1_NAME;
                        customer['selected'] = true;
                        return customer;
                    });
                    return company;
                });
            } else if (this.filters['parentView'] === 'master-customer') {
                this.record.companies = [];
                this.record.masterCustomers = result.data.map(masterCustomer => {
                    masterCustomer['label'] = masterCustomer.CU0_SHORT_CODE + ' - ' + masterCustomer.CU0_NAME;
                    masterCustomer['selected'] = (Number(masterCustomer.selected) === 1);
                    masterCustomer['children'] = masterCustomer.children.map(plant => {
                        plant['label'] = plant.PL1_NAME;
                        // plant['selected'] = (Number(plant.selected) === 1);
                        plant['selected'] = true;
                        return plant;
                    });
                    return masterCustomer;
                });
            } else {
                this.record.masterCustomers = [];
                this.record.companies = [];
            }
            if (modelData != null) {
                this.applyModel( modelData );
            }
        }, () => {
            this.toast.error('Failed to load required data.', 'Error');
            this.clickCancel();
        });
    }

    clickCancel() {
        this.loading = false;
        this.router.navigate(['user']);
    }

    clickSave() {
        // validate fields
        let recordsValid = true;
        let errorsTab1 = false;
        let errorsTab2 = false;
        this.errors = {};
        if (this.record.username == null || this.record.username.toString().trim() === '') {
            this.errors['username'] = ['Username is required.']; recordsValid = false; errorsTab1 = true;
        }
        if (this.record.name == null || this.record.name.toString().trim() === '') {
            this.errors['name'] = ['Name is required.']; recordsValid = false; errorsTab1 = true;
        }
        if (this.record.email == null || this.record.email.toString().trim() === '') {
            this.errors['email'] = ['Email is required.']; recordsValid = false; errorsTab1 = true;
        }
        if (this.record.status == null) {
            this.errors['status'] = ['Status is required.']; recordsValid = false; errorsTab1 = true;
        }
        if (this.action === 'create' || this.allowPasswordUpdate) {
            if (this.record.password == null || this.record.password.toString().trim() === '') {
                this.errors['password'] = ['Password cannot be empty.']; recordsValid = false; errorsTab1 = true;
            }
            if (this.record.repeatPassword == null || this.record.repeatPassword.toString().trim() === '') {
                this.errors['repeatPassword'] = ['Repeat Password cannot be empty.']; recordsValid = false; errorsTab1 = true;
            }
        }
        if (this.record.role == null || this.record.role.toString().trim() === '') {
            this.errors['role'] = ['Role is required.']; recordsValid = false; errorsTab2 = true;
        }

        if (!this.errors.hasOwnProperty('role')) {
            if (this.record.role.toString() === this.roles.oesCompanyAdmin || this.record.role.toString() === this.roles.oesCompanyUser) {
                let companies = JSON.parse(JSON.stringify(this.record)).companies.slice();
                if (companies.length < 1) {
                    this.errors['companies'] = ['Unable to create a user without any access rights.'];
                    recordsValid = false; errorsTab2 = true;
                } else {
                    companies = companies.filter(company => company.selected);
                    if (companies.length < 1) {
                        this.errors['companies'] = ['Must provide access rights to at least one company.'];
                        recordsValid = false; errorsTab2 = true;
                    }
                    this.errors['customers'] = [];
                    if (this.record.role.toString() === this.roles.oesCompanyUser) {
                        for (const company of companies) {
                            if (company.children.length < 1) {
                                this.errors['customers'].push(
                                    ['Unable to create a user without any customer-level access rights (' + company['label'] + ').']
                                );
                                recordsValid = false;
                                errorsTab2 = true;
                            } else {
                                if (company.children.filter(customer => customer.selected).length < 1) {
                                    this.errors['customers'].push(
                                        ['Must provide access rights to at least one customer under each selected company.']
                                    );
                                    recordsValid = false;
                                    errorsTab2 = true;
                                }
                            }
                        }
                    }
                }
            } else if (this.record.role.toString() === this.roles.oesMasterCustomerUser) {
                let masterCustomers = JSON.parse(JSON.stringify(this.record)).masterCustomers.slice();
                if (masterCustomers.length < 1) {
                    this.errors['masterCustomers'] = ['Unable to create a user without any access rights.'];
                    recordsValid = false; errorsTab2 = true;
                } else {
                    masterCustomers = masterCustomers.filter(masterCustomer => masterCustomer.selected);
                    if (masterCustomers.length < 1) {
                        this.errors['masterCustomers'] = ['Must provide access rights to at least one customer.'];
                        recordsValid = false; errorsTab2 = true;
                    }
                    this.errors['plants'] = [];
                    for (const masterCustomer of masterCustomers) {
                        if (masterCustomer.children.length < 1) {
                            this.errors['plants'].push(
                                ['Unable to create a user without any plant-level access rights (' + masterCustomer['label'] + ').']
                            );
                            recordsValid = false;
                            errorsTab2 = true;
                        } else {
                            if (masterCustomer.children.filter(plant => plant.selected).length < 1) {
                                this.errors['plants'].push(
                                    ['Must provide access rights to at least one plant under each selected customer.']
                                );
                                recordsValid = false;
                                errorsTab2 = true;
                            }
                        }
                    }
                    if (this.errors['plants'].length < 1) {
                        delete this.errors['plants'];
                    }
                }
            }
        }

        // extract model and submit to backend
        if (recordsValid) {
            this.loading = true;
            const newUser = (this.action === 'create');
            this.userService.saveSubordinate( this.extractModel(), newUser ).subscribe(result => {
                if (result.success) {
                    this.toast.success('User ' + (newUser ? 'created' : 'saved') + '!', 'Success');
                    this.clickCancel();
                } else {
                    this.toast.error('Failed to ' + (newUser ? 'create' : 'save') + ' user.', 'Error');
                    this.mapErrors(result.errors);
                }
                this.loading = false;
            }, () => {
                this.toast.error('User ' + (newUser ? 'creation' : 'update') + ' request timed out.', 'Service Error');
                this.loading = false;
            });
        } else {
            if (errorsTab1) {
                this.tabGroup.selectedIndex = 0;
            } else {
                if (errorsTab2) {
                    this.tabGroup.selectedIndex = 1;
                }
            }
        }
    }

    mapErrors( errors ) {
        this.errors = {};
        let tab1Errors = false;
        let tab2Errors = false;
        if (errors.hasOwnProperty('user')) {
            if (errors.user.hasOwnProperty('username')) {
                this.errors['username'] = errors.user.username;
                tab1Errors = true;
            }
            if (errors.user.hasOwnProperty('name')) {
                this.errors['name'] = errors.user.name;
                tab1Errors = true;
            }
            if (errors.user.hasOwnProperty('email')) {
                this.errors['email'] = errors.user.email;
                tab1Errors = true;
            }
            if (errors.user.hasOwnProperty('status')) {
                this.errors['status'] = errors.user.status;
                tab1Errors = true;
            }
            if (errors.user.hasOwnProperty('password')) {
                this.errors['password'] = errors.user.password;
                tab1Errors = true;
            }
            if (errors.user.hasOwnProperty('repeat_password')) {
                this.errors['repeatPassword'] = errors.user.repeat_password;
                tab1Errors = true;
            }
        }
        if (errors.hasOwnProperty('role')) {
            this.errors['role'] = errors.role;
            tab2Errors = true;
        }
        if (tab1Errors) {
            this.tabGroup.selectedIndex = 0;
        } else {
            if (tab2Errors) {
                this.tabGroup.selectedIndex = 1;
            }
        }
    }

    extractModel() {
        const record = JSON.parse(JSON.stringify(this.record));
        const userData = {
            user: {
                name: record.name,
                username: record.username,
                email: record.email,
                status: record.status,
                password: record.password,
                repeat_password: record.repeatPassword
            },
            updatePassword: this.allowPasswordUpdate ? 1 : 0,
            role: record.role,
            accessData: {
                companies: record.companies.slice().filter(company => company.selected).map(company => {
                    const filteredChildren = JSON.parse(JSON.stringify(company.children)).filter(customer => customer.selected);
                    if (filteredChildren.length > 0 && filteredChildren.length === company.children.length) {
                        company['children'] = [];
                    } else {
                        company['children'] = company.children.filter(customer => customer.selected);
                    }
                    return company;
                }),
                masterCustomers: record.masterCustomers.slice().filter(masterCustomer => masterCustomer.selected).map(masterCustomer => {
                    const filteredChildren = JSON.parse(JSON.stringify(masterCustomer.children)).filter(plant => plant.selected);
                    if (filteredChildren.length > 0 && filteredChildren.length === masterCustomer.children.length) {
                        masterCustomer['children'] = [];
                    } else {
                        masterCustomer['children'] = masterCustomer.children.filter(plant => plant.selected);
                    }
                    return masterCustomer;
                })
            }
        };
        if (this.action === 'edit') {
            userData['user']['id'] = record.id;
            if (!this.allowPasswordUpdate) {
                delete userData['user']['password'];
                delete userData['user']['repeat_password'];
            }
        }
        return userData;
    }

    applyModel( userData ) {
        this.record.id = userData.user.hasOwnProperty('id') ? userData.user.id : null;
        this.record.name = userData.user.name;
        this.record.username = userData.user.username;
        this.record.email = userData.user.email;
        this.record.status = Number(userData.user.status);
        if (this.action === 'create') {
            this.record.password = userData.user.password;
            this.record.repeatPassword = userData.user.repeat_password;
        }
        this.record.role = userData.role;
        for (let index = 0; index < this.record.companies.length; index++) {
            const userDataMatch = userData.accessData.companies.filter(
                company => Number(company.CO1_ID) === Number(this.record.companies[index].CO1_ID)
            );
            if (userDataMatch.length === 1) {
                this.record.companies[index].selected = true;
                if (userDataMatch[0].children.length > 0) {
                    for (let cIndex = 0; cIndex < this.record.companies[index].children.length; cIndex++) {
                        const customerMatch = userDataMatch[0].children.filter(
                            customer => (
                                Number(customer.CU1_ID) === Number(this.record.companies[index].children[cIndex].CU1_ID)
                                && Number(customer.CO1_ID) === Number(this.record.companies[index].children[cIndex].CO1_ID)
                            )
                        );
                        this.record.companies[index].children[cIndex].selected = (customerMatch.length > 0);
                    }
                } else {
                    for (let cIndex = 0; cIndex < this.record.companies[index].children.length; cIndex++) {
                        this.record.companies[index].children[cIndex].selected = true;
                    }
                }
            }
        }
        for (let index = 0; index < this.record.masterCustomers.length; index++) {
            const userDataMatch = userData.accessData.masterCustomers.filter(
                masterCustomer => Number(masterCustomer.CU0_ID) === Number(this.record.masterCustomers[index].CU0_ID)
            );
            if (userDataMatch.length === 1) {
                this.record.masterCustomers[index].selected = true;
                if (userDataMatch[0].children.length > 0) {
                    for (let pIndex = 0; pIndex < this.record.masterCustomers[index].children.length; pIndex++) {
                        const plantMatch = userDataMatch[0].children.filter(
                            plant => (
                                Number(plant.PL1_ID) === Number(this.record.masterCustomers[index].children[pIndex].PL1_ID)
                            )
                        );
                        this.record.masterCustomers[index].children[pIndex].selected = (plantMatch.length > 0);
                    }
                } else {
                    for (let pIndex = 0; pIndex < this.record.masterCustomers[index].children.length; pIndex++) {
                        this.record.masterCustomers[index].children[pIndex].selected = true;
                    }
                }
            }
        }
        this.loading = false;
    }

    onChangeUserStatus(value: number) {
        this.record.status = value;
    }

    onSelectAllCustomers(companyIndex: number) {
        for (let cIndex = 0; cIndex < this.record.companies[companyIndex].children.length; cIndex++) {
            this.record.companies[companyIndex].children[cIndex].selected = true;
        }
    }

    onSelectAllPlants(masterCustomerIndex: number) {
        for (let pIndex = 0; pIndex < this.record.masterCustomers[masterCustomerIndex].children.length; pIndex++) {
            this.record.masterCustomers[masterCustomerIndex].children[pIndex].selected = true;
        }
    }

    nextTab() {
        if (this.tabGroup) {
            this.tabGroup.selectedIndex = 1;
        }
    }

    onChangeRole(value: string) {
        if ((this.record.role == null && value != null) || (this.record.role.toString() !== value)) {
            this.record.role = value;
            if (value === this.roles.oesCompanyAdmin) {
                this.filters['parentView'] = 'company';
                this.filters['childView'] = 'none';
            } else if (value === this.roles.oesCompanyUser) {
                this.filters['parentView'] = 'company';
                this.filters['childView'] = 'customer';
            } else if (value === this.roles.oesMasterCustomerUser) {
                this.filters['parentView'] = 'master-customer';
                this.filters['childView'] = 'plant';
            } else {
                this.filters['parentView'] = 'none';
                this.filters['childView'] = 'none';
            }
            this.clearAccessSelections();
            this.preloadData();
        }
    }

    clearAccessSelections() {
        for (let index = 0; index < this.record.companies.length; index++) {
            this.record.companies[index].selected = false;
            this.record.companies[index].children = [];
        }
        for (let index = 0; index < this.record.masterCustomers.length; index++) {
            this.record.masterCustomers[index].selected = false;
            this.record.masterCustomers[index].children = [];
        }
    }

    passwordUpdateToggled() {
        if (this.action !== 'create') {
            this.record.password = '';
            this.record.repeatPassword = '';
            if (this.errors.hasOwnProperty('password')) {
                delete this.errors['password'];
            }
            if (this.errors.hasOwnProperty('repeatPassword')) {
                delete this.errors['repeatPassword'];
            }
        }
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-form/user-form.component.ts